import { useMemo } from "react";
import { useParams } from "react-router";
import { createPortal } from "react-dom";
import useProductLicenseForm from "core/hooks/useProductLicenseForm";
import ButtonLink from "core/components/ButtonLink";
import Navigate from "core/components/Navigate";
import Error from "core/components/Error";
import ProductPage from "modules/admin/OrgProductLicenseForm/ProductPage";
import AnimatedProductPageContainer from "modules/admin/OrgProductLicenseForm/AnimatedProductPageContainer";
import { PRODUCTS } from "modules/admin/OrgProductLicenseForm/products";

const productRoutes = Object.values(PRODUCTS).map((product) => ({
  bundlePath: product.meta.bundle.path,
  productPath: product.page.path,
  product,
}));

const ProductLicenseProductPage = () => {
  const { bundlePath, productPath } = useParams();
  const { formState, catalogByProduct, catalogError } = useProductLicenseForm();

  const { getDynamicProduct, getPreparedLicenses } = formState;

  const route = useMemo(() => {
    return productRoutes.find(
      (r) => r.bundlePath === bundlePath && r.productPath === productPath
    );
  }, [bundlePath, productPath]);

  if (!route) {
    return <Navigate replace to="../summary" />;
  }

  if (!catalogByProduct) {
    return null;
  }

  const { product } = route;
  const dynamicProduct = getDynamicProduct(product.id);
  const error = catalogError;
  const stickyReviewEl = document.querySelector("#stickyLicenseReview");

  return (
    <div>
      <div
        style={{
          position: "relative",
          width: "100%",
          paddingBottom: "100px",
        }}
      >
        <Error style={{ marginBottom: "10px" }}>{error}</Error>
        <AnimatedProductPageContainer>
          <ProductPage product={dynamicProduct} catalog={catalogByProduct} />
        </AnimatedProductPageContainer>
      </div>
      {stickyReviewEl
        ? createPortal(
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "8px 12px",
              }}
            >
              <ButtonLink to="../confirm" disabled={!getPreparedLicenses()}>
                Review Deployment
              </ButtonLink>
            </div>,
            stickyReviewEl
          )
        : null}
    </div>
  );
};

export default ProductLicenseProductPage;
